import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
		if (this.props.location.hash) {
			var location = document.getElementById(this.props.location.hash.slice(1)).offsetTop;
    		window.scrollTo({top: location - 65, behavior: 'smooth'});
		}
		else {
	      window.scrollTo(0, 0)
		}
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)
